// @flow

export type { IDocumentTypeChecksExtend } from './extenders/checks';
export type { IDocumentTypeInputmaskExtend } from './extenders/inputmask';

export { identityDocumentTypeChecksExtend } from './extenders/checks';
export { documentTypeInputMaskExtend } from './extenders/inputmask';